module.exports = __webpack_public_path__ + "img/google.8937e4a9.png";